import {
  ACL_MODULE_MAPPING,
  MODULE_ACL_SWITCH,
} from "../../constants/RouteConstant";
import {
  plumPaymentHistoryReq,
  empulsPaymentHistory,
  plumProPaymentHistory,
  voucherRechargeHistory,
} from "../reports/";
import { app_path } from "config";

const getActiveWallets = (
  moduleAclArray = [],
  accountReducer = {},
  isfromDashBoard = false
) => {
  const {
    plumProPoints = {},
    typeData: { walletCompany = 1 } = {},
    userBalance: { companyBalance = 0, userBalance = 0 } = {},
  } = accountReducer;
  let xoxoPointVoucherTitle = "";
  xoxoPointVoucherTitle = moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT)
    ? "Points"
    : "";
  if (
    moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
    moduleAclArray.includes(ACL_MODULE_MAPPING.MAGIC_VOUCHER)
  ) {
    xoxoPointVoucherTitle
      ? (xoxoPointVoucherTitle += "/Code")
      : (xoxoPointVoucherTitle = "Code");
  }

  if (MODULE_ACL_SWITCH == false) {
    xoxoPointVoucherTitle = "";
  }
  let walletThree = 1;
  if (walletCompany == 1) {
    walletThree = 0;

    moduleAclArray.includes(ACL_MODULE_MAPPING.WALLET)
      ? xoxoPointVoucherTitle
        ? (xoxoPointVoucherTitle += "/Tokens")
        : (xoxoPointVoucherTitle = "Tokens")
      : null;

    moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
    moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO_API)
      ? xoxoPointVoucherTitle
        ? (xoxoPointVoucherTitle += "/Plum Pro")
        : (xoxoPointVoucherTitle = "Plum Pro")
      : null;

    moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK)
      ? xoxoPointVoucherTitle
        ? (xoxoPointVoucherTitle += "/Link")
        : (xoxoPointVoucherTitle = "Link")
      : null;
  }

  xoxoPointVoucherTitle
    ? (xoxoPointVoucherTitle = "Xoxo " + xoxoPointVoucherTitle + " Fund")
    : null;

  let plumProTitle = "";
  if (walletThree === 1) {
    moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
    moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO_API)
      ? (plumProTitle += "Plum Pro ")
      : "";
    moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK)
      ? plumProTitle
        ? (plumProTitle += "/Xoxo Link ")
        : (plumProTitle = "Xoxo Link ")
      : "";
    plumProTitle += "Funds";
  }

  const activeWallets = [];
  if (
    MODULE_ACL_SWITCH == false ||
    moduleAclArray.includes(ACL_MODULE_MAPPING.EMPULS)
  ) {
    const json = {
      className: "card-box-primary points",
      title: isfromDashBoard ? "Empuls Balance" : "Empuls Funds",
      subTitle: companyBalance,
      content: "",
      btnText: "Add Funds",
      btnColor: "transparent",
      callBack: {
        company_recharge: 1,
        product_type: 2,
      },
      showThreshold: false,
      reportsRedirection: `/${app_path}/reports/empuls-report`,
      reportsRequest: empulsPaymentHistory,
    };
    activeWallets.push(json);
  }
  if ((MODULE_ACL_SWITCH == false || xoxoPointVoucherTitle) && walletThree) {
    const json = {
      className: "card-glass-tertiary points",
      title: isfromDashBoard ? "Wallet Balance" : "Wallet Funds",
      subTitle: userBalance,
      content: "",
      btnText: "Add Funds",
      btnColor: "transparent",
      callBack: {
        company_recharge: 0,
        product_type: 1,
      },
      showThreshold: false,
      reportsRedirection: `/${app_path}/reports/voucher-recharge`,
      reportsRequest: voucherRechargeHistory,
    };
    activeWallets.push(json);
  }
  if (
    (MODULE_ACL_SWITCH == false ||
      moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
      moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO_API) ||
      moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK)) &&
    walletThree
  ) {
    const json = {
      className: "card-glass-secondary points",
      title: plumProTitle,
      subTitle: (plumProPoints && plumProPoints.balance) || "",
      content: "",
      btnText: "Add Funds",
      btnColor: "transparent",
      callBack: {
        company_recharge: 2,
        product_type: 3,
      },
      showThreshold: true,
      reportsRedirection: `/${app_path}/reports/plum-pro-report`,
      reportsRequest: plumProPaymentHistory,
    };
    activeWallets.push(json);
  }
  if (
    walletThree == 0 &&
    (MODULE_ACL_SWITCH == false || xoxoPointVoucherTitle)
  ) {
    const json = {
      className: "card-glass-secondary points",
      title: isfromDashBoard ? "Wallet Balance" : "Wallet Funds",
      subTitle: userBalance,
      content: "",
      btnText: "Add Funds",
      btnColor: "transparent",
      callBack: {
        company_recharge: 2,
        product_type: 4,
      },
      showThreshold: false,
      reportsRedirection: `/${app_path}/reports/xoxo-token-report`,
      reportsRequest: plumPaymentHistoryReq,
    };
    activeWallets.push(json);
  }
  return activeWallets;
};

export default getActiveWallets;
